import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import moment from 'moment';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { Accordion, Tab, Tabs } from "react-bootstrap";
import { Tooltip, Tree } from 'antd';
import uuid from 'react-uuid';

import { setCookie, getCookie } from '../common_component/cookie.js';
import StatusBadge from "../common_component/StatusBadge.js";
import formatNumber from "../common_component/formatNumber.js";
import PageError from "../common_component/PageError.js";
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import Rating from "react-rating";

const formatNumberOptions = {
    decimalPlaces: 2,
    removeTrailingZeros: true,
    currencyFormat: '1,234,567.89'
};

export const ViewEcommerceOrder = (props) => {
    const [warehouseList, setWarehouseList] = useState([]);

    const [ecomOrderDetails, setEcomOrderDetails] = useState([]);
    const [ecomOrderHistoryDetails, setEcomOrderHistoryDetails] = useState([])

    const [activeTab, setActiveTab] = useState("order_summary")

    const [submitButtonState, setSubmitButtonState] = useState(false);

    const [state, setstate] = useState(2);
    const history = useHistory()
    const location = useLocation();

    var page_name = "view-ecommerce-order";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    useEffect(() => {
        async function getEcommerceOrderDetails() {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-order-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "order_id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();

            if (body.operation === "success") {
                setEcomOrderDetails(body.data);
                setstate(1);
            }
            else {
                setstate(3);
            }
        }

        async function getEcommerceOrderHistoryDetails() {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-order-history-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "order_id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation === "success" && body.data.length > 0) {
                setEcomOrderHistoryDetails(body.data);
            }
        }

        async function getWarehouseList() {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/list-warehouse`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            // console.log(body)
            if (body.operation == "success") {
                setWarehouseList(body.data);
            }
        }

        if ((read || write) && (user.email && visibility)) {
            getEcommerceOrderDetails();
            getEcommerceOrderHistoryDetails();
            getWarehouseList();
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (location.state) {
            setActiveTab(location.state.activeTab)
        }
    }, [location.state])

    const cancelOrderSubmit = (cancel_msg) => {

        var object = {};

        object.cancel_msg = cancel_msg
        object.order_id = props.match.params.id
        object.user_email = user.email

        object.organization_id = organization_id
        object.page_name = page_name;

        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-ecommerce-order`, object, headers).then((res) => {
            setSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", `Operation Success and ${res.data.message}!`, "success").then((value) => { history.push(`/ecommerce-orders`) });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const newWarehouseProcessingSubmit = () => {
        var object = {}

        object.order_id = props.match.params.id;
        object.organization_id = organization_id;
        object.page_name = page_name;

        console.log(object);
        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/process-ecommerce-order-warehouse`, object, headers).then((res) => {
            setSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success").then((value) => { history.push(`/ecommerce-warehouse-processing-list`) });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">View Order Details</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/ecommerce/ecommerce_orders#view-ecommerce-order-page`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                        {
                            ecomOrderDetails.order_status === "ECOMMERCE_ORDER_CONFIRMED" && (
                                <button className='btn btn-danger btn-sm' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}
                                    onClick={() => {
                                        swal({ title: "Alert!", text: "Please type a reason before cancelling", icon: "warning", content: "input", buttons: true, dangerMode: true, })
                                            .then((msg) => {
                                                if (msg === "") {
                                                    swal("Alert!", "Message cannot be empty", "warning")
                                                    return
                                                }
                                                else if (msg) {
                                                    cancelOrderSubmit(msg);
                                                }
                                            });
                                    }}
                                >
                                    <span className="indicator-label">Cancel Order</span>
                                    <span className="indicator-progress">Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            )
                        }
                        {
                            ecomOrderDetails.order_status === "ECOMMERCE_ORDER_CONFIRMED" &&
                            <button className="btn btn-success btn-sm rounded me-6" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { newWarehouseProcessingSubmit() }}>
                                <span className="indicator-label">Process to Warehouse</span>
                                <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        }
                    </div>
                </div>
                <div>
                    {
                        state === 1 ?
                            <div className="d-flex flex-column gap-7">
                                <Tabs
                                    activeKey={activeTab}
                                    onSelect={(k) => setActiveTab(k)}
                                    // className="mb-3 nav-line-tabs nav-line-tabs-2x fs-4 text-active-primary"
                                    variant="pills"
                                >
                                    <Tab eventKey="order_summary" title="Order Summary">
                                        <EcommerceOrderSummary ecomOrderDetails={ecomOrderDetails} />
                                    </Tab>
                                    <Tab eventKey="order_history" title="Order History">
                                        <div className="d-flex flex-column gap-7 gap-lg-10">
                                            <div className="card card-flush py-4 flex-row-fluid">

                                                <div className="card-body pt-0">
                                                    {
                                                        ecomOrderHistoryDetails.length > 0 ?
                                                            <div className="table-responsive">
                                                                <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                                                    <thead>
                                                                        <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                                            <th className="min-w-100px">Date Added</th>
                                                                            <th className="min-w-175px">Comment</th>
                                                                            <th className="min-w-70px">Order Status</th>
                                                                            <th className="min-w-100px">Customer Notifed</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="fw-semibold text-gray-600">
                                                                        {
                                                                            ecomOrderHistoryDetails.map((Obj, index) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <td>{moment(Obj.timestamp).format("ll")}</td>
                                                                                        <td>{Obj.operation_message}</td>
                                                                                        <td><StatusBadge status={Obj.order_status} entity={"ECOMMERCE_ORDER"} /></td>
                                                                                        <td>No</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            :
                                                            <div className="text-center text-gray-600 fs-2">No order history available.</div>
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="associated_invoices" title="Associated Invoices">
                                        {
                                            ecomOrderDetails.associated_invoices.length ?
                                                <EcommerceOrderAssociatedInvoices invoiceList={ecomOrderDetails.associated_invoices} />
                                                :
                                                <div className="text-center text-gray-600 fs-2">No Invoices Created Yet</div>
                                        }
                                    </Tab>
                                    <Tab eventKey="warehouse_processing_summary" title="Warehouse Processing Summary">
                                        {
                                            (ecomOrderDetails.warehouse_processing_summary.length && warehouseList.length) ?
                                                <EcommerceWarehouseProcessingSummary warehouseProcessingDetails={ecomOrderDetails.warehouse_processing_summary} warehouseList={warehouseList} />
                                                :
                                                <div className="text-center text-gray-600 fs-2">No Warehouse Processing Started Yet</div>
                                        }
                                    </Tab>
                                    <Tab eventKey="associated_challans" title="Associated Challans">
                                        {
                                            (ecomOrderDetails.associated_challans.length && warehouseList.length) ?
                                                <EcommerceOrderAssociatedChallans deliveryChallanList={ecomOrderDetails.associated_challans} warehouseList={warehouseList} />
                                                :
                                                <div className="text-center text-gray-600 fs-2">No Delivery Challans Created Yet</div>
                                        }
                                    </Tab>
                                    <Tab eventKey="order_reviews" title="Order Review">
                                        {
                                            (ecomOrderDetails.ecom_order_reviews !== undefined && ecomOrderDetails.ecom_order_reviews.length > 0) ?
                                                <div className="container mt-4">
                                                    <div className="card mb-3">
                                                        <div className="card-body">
                                                            <h5 className="card-title">{ecomOrderDetails.ecom_order_reviews[0].account_name}</h5>
                                                            <Rating
                                                                initialRating={ecomOrderDetails.ecom_order_reviews[0].rating}
                                                                readonly
                                                                emptySymbol="far fa-star"
                                                                fullSymbol="fas fa-star"
                                                                style={{ color: "#fdbc0a" }}
                                                            />
                                                            <p className="card-text mt-2">{ecomOrderDetails.ecom_order_reviews[0].review}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="text-center text-gray-600 fs-2">No reviews available</div>
                                        }
                                    </Tab>
                                </Tabs>
                            </div>
                            : state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div>
        </>
    );
};

export const EcommerceOrderSummary = ({ ecomOrderDetails }) => {
    return (
        <>
            {
                ecomOrderDetails &&
                <div className="d-flex flex-column gap-7 gap-lg-10">
                    <div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
                        <div className="card card-flush py-6 flex-row-fluid">
                            <div className="card-header">
                                <div className="card-title">
                                    <h2>Order Details (#{ecomOrderDetails.ref_order_id})</h2>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
                                        <tbody className="fw-semibold text-gray-600">
                                            <tr>
                                                <td className="text-muted">
                                                    <div className="d-flex align-items-center">
                                                        <span className="svg-icon svg-icon-2 me-2">
                                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
                                                                <path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>Status
                                                    </div>
                                                </td>
                                                <td className="fw-bold text-end">
                                                    <StatusBadge status={ecomOrderDetails.order_status} entity={"ECOMMERCE_ORDER"} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">
                                                    <div className="d-flex align-items-center">
                                                        <span className="svg-icon svg-icon-2 me-2">
                                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
                                                                <path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>Order Date
                                                    </div>
                                                </td>
                                                <td className="fw-bold text-end">{moment(ecomOrderDetails.order_date).format("DD-MM-YYYY")}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">
                                                    <div className="d-flex align-items-center">
                                                        <span className="svg-icon svg-icon-2 me-2">
                                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
                                                                <path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>Order Number
                                                    </div>
                                                </td>
                                                <td className="fw-bold text-end">{ecomOrderDetails.order_number}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
                        <div className="card card-flush py-6 flex-row-fluid">
                            <div className="card-header">
                                <div className="card-title">
                                    <h2>User Details</h2>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
                                        <tbody className="fw-semibold text-gray-600">
                                            <tr>
                                                <td className="text-muted">
                                                    <div className="d-flex align-items-center">
                                                        <span className="svg-icon svg-icon-2 me-2">
                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                            </svg>
                                                        </span>User Name
                                                    </div>
                                                </td>
                                                <td className="fw-bold text-end">{ecomOrderDetails.billing_address.first_name + ecomOrderDetails.billing_address.last_name}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">
                                                    <div className="d-flex align-items-center">
                                                        <span className="svg-icon svg-icon-2 me-2">
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z" fill="currentColor"></path>
                                                                <path d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>User Email
                                                    </div>
                                                </td>
                                                <td className="fw-bold text-end">{ecomOrderDetails.billing_address.email}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="card card-flush py-6 flex-row-fluid">
                            <div className="card-header">
                                <div className="card-title">
                                    <h2>Other Details</h2>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
                                        <tbody className="fw-semibold text-gray-600">
                                            <tr>
                                                <td className="text-muted">
                                                    <div className="d-flex align-items-center">
                                                        <span className="svg-icon svg-icon-2 me-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone-fill" viewBox="0 0 16 16">
                                                                <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                                            </svg>
                                                        </span>Phone Number
                                                    </div>
                                                </td>
                                                <td className="fw-bold text-end">{ecomOrderDetails.billing_address.phone_number}</td>
                                            </tr>
                                            {/* <tr>
                                                                            <td className="text-muted">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span className="svg-icon svg-icon-2 me-2">
                                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path d="M20 8H16C15.4 8 15 8.4 15 9V16H10V17C10 17.6 10.4 18 11 18H16C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18H21C21.6 18 22 17.6 22 17V13L20 8Z" fill="currentColor"></path>
                                                                                            <path opacity="0.3" d="M20 18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18ZM15 4C15 3.4 14.6 3 14 3H3C2.4 3 2 3.4 2 4V13C2 13.6 2.4 14 3 14H15V4ZM6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16Z" fill="currentColor"></path>
                                                                                        </svg>
                                                                                    </span>Zip code
                                                                                </div>
                                                                            </td>
                                                                            <td className="fw-bold text-end">{ecomOrderDetails.billing_address.zip_code}</td>
                                                                        </tr> */}
                                            <tr>
                                                <td className="text-muted">
                                                    <div className="d-flex align-items-center">
                                                        <span className="svg-icon svg-icon-2 me-2">
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.3" d="M21.6 11.2L19.3 8.89998V5.59993C19.3 4.99993 18.9 4.59993 18.3 4.59993H14.9L12.6 2.3C12.2 1.9 11.6 1.9 11.2 2.3L8.9 4.59993H5.6C5 4.59993 4.6 4.99993 4.6 5.59993V8.89998L2.3 11.2C1.9 11.6 1.9 12.1999 2.3 12.5999L4.6 14.9V18.2C4.6 18.8 5 19.2 5.6 19.2H8.9L11.2 21.5C11.6 21.9 12.2 21.9 12.6 21.5L14.9 19.2H18.2C18.8 19.2 19.2 18.8 19.2 18.2V14.9L21.5 12.5999C22 12.1999 22 11.6 21.6 11.2Z" fill="currentColor"></path>
                                                                <path d="M11.3 9.40002C11.3 10.2 11.1 10.9 10.7 11.3C10.3 11.7 9.8 11.9 9.2 11.9C8.8 11.9 8.40001 11.8 8.10001 11.6C7.80001 11.4 7.50001 11.2 7.40001 10.8C7.20001 10.4 7.10001 10 7.10001 9.40002C7.10001 8.80002 7.20001 8.4 7.30001 8C7.40001 7.6 7.7 7.29998 8 7.09998C8.3 6.89998 8.7 6.80005 9.2 6.80005C9.5 6.80005 9.80001 6.9 10.1 7C10.4 7.1 10.6 7.3 10.8 7.5C11 7.7 11.1 8.00005 11.2 8.30005C11.3 8.60005 11.3 9.00002 11.3 9.40002ZM10.1 9.40002C10.1 8.80002 10 8.39998 9.90001 8.09998C9.80001 7.79998 9.6 7.70007 9.2 7.70007C9 7.70007 8.8 7.80002 8.7 7.90002C8.6 8.00002 8.50001 8.2 8.40001 8.5C8.40001 8.7 8.30001 9.10002 8.30001 9.40002C8.30001 9.80002 8.30001 10.1 8.40001 10.4C8.40001 10.6 8.5 10.8 8.7 11C8.8 11.1 9 11.2001 9.2 11.2001C9.5 11.2001 9.70001 11.1 9.90001 10.8C10 10.4 10.1 10 10.1 9.40002ZM14.9 7.80005L9.40001 16.7001C9.30001 16.9001 9.10001 17.1 8.90001 17.1C8.80001 17.1 8.70001 17.1 8.60001 17C8.50001 16.9 8.40001 16.8001 8.40001 16.7001C8.40001 16.6001 8.4 16.5 8.5 16.4L14 7.5C14.1 7.3 14.2 7.19998 14.3 7.09998C14.4 6.99998 14.5 7 14.6 7C14.7 7 14.8 6.99998 14.9 7.09998C15 7.19998 15 7.30002 15 7.40002C15.2 7.30002 15.1 7.50005 14.9 7.80005ZM16.6 14.2001C16.6 15.0001 16.4 15.7 16 16.1C15.6 16.5 15.1 16.7001 14.5 16.7001C14.1 16.7001 13.7 16.6 13.4 16.4C13.1 16.2 12.8 16 12.7 15.6C12.5 15.2 12.4 14.8001 12.4 14.2001C12.4 13.3001 12.6 12.7 12.9 12.3C13.2 11.9 13.7 11.7001 14.5 11.7001C14.8 11.7001 15.1 11.8 15.4 11.9C15.7 12 15.9 12.2 16.1 12.4C16.3 12.6 16.4 12.9001 16.5 13.2001C16.6 13.4001 16.6 13.8001 16.6 14.2001ZM15.4 14.1C15.4 13.5 15.3 13.1 15.2 12.9C15.1 12.6 14.9 12.5 14.5 12.5C14.3 12.5 14.1 12.6001 14 12.7001C13.9 12.8001 13.8 13.0001 13.7 13.2001C13.6 13.4001 13.6 13.8 13.6 14.1C13.6 14.7 13.7 15.1 13.8 15.4C13.9 15.7 14.1 15.8 14.5 15.8C14.8 15.8 15 15.7 15.2 15.4C15.3 15.2 15.4 14.7 15.4 14.1Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>Currency
                                                    </div>
                                                </td>
                                                <td className="fw-bold text-end">{ecomOrderDetails.order_currency.currency_code}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
                        <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
                            <div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
                                <img src="/assets/media/icons/duotune/ecommerce/ecm001.svg" className="w-175px" alt="Location Icon" />
                            </div>
                            <div className="card-header">
                                <div className="card-title">
                                    <h2>Billing Address</h2>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <div className="address-info">
                                    <div className="location">
                                        <i className="fas fa-map-marker-alt"></i> {ecomOrderDetails.billing_address.address}, {ecomOrderDetails.billing_address.city}, {ecomOrderDetails.billing_address.state}
                                    </div>
                                    <div className="pincode">
                                        <i className="fas fa-thumbtack"></i> {ecomOrderDetails.billing_address.zip_code}
                                    </div>
                                    <div className="country">
                                        <i className="fas fa-globe"></i> {ecomOrderDetails.billing_address?.country || "India"}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
                                                        <div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
                                                            <img src="/assets/media/icons/duotune/ecommerce/ecm006.svg" className="w-175px" alt="Location Icon" />
                                                        </div>
                                                        <div className="card-header">
                                                            <div className="card-title">
                                                                <h2>Shipping Address</h2>
                                                            </div>
                                                        </div>
                                                        <div className="card-body pt-0">
                                                            <div className="address-info">
                                                                <div className="location">
                                                                    <i className="fas fa-map-marker-alt"></i> {ecomOrderDetails.shipping_address.city}, {ecomOrderDetails.shipping_address.state}
                                                                </div>
                                                                <div className="pincode">
                                                                    <i className="fas fa-thumbtack"></i> {ecomOrderDetails.shipping_address.pincode}
                                                                </div>
                                                                <div className="country">
                                                                    <i className="fas fa-globe"></i> {ecomOrderDetails.shipping_address.country}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                    </div>

                    <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
                        <div className="card-header align-items-center py-5 gap-2 gap-md-5">
                            <div className="card-title">
                                <h2>Order #{ecomOrderDetails.ref_order_id}</h2>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="d-flex justify-content-between flex-column">
                                <div className="d-flex justify-content-between flex-column">
                                    <div className="table-responsive border-bottom mb-9">
                                        <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                            <thead>
                                                <tr className="border-bottom fs-6 fw-bold text-muted">
                                                    <th className="min-w-100px">Products</th>
                                                    <th className="min-w-70px">Quantity</th>
                                                    <th className="min-w-70px">Rate<br />(Tax Exclusive)</th>
                                                    <th className="min-w-70px">Total Amt.</th>
                                                    <th className="min-w-70px">Tax Percentage</th>
                                                    <th className="min-w-70px">Tax Amount</th>
                                                    <th className="min-w-100px text-end pb-2">Line Total</th>
                                                </tr>
                                            </thead>
                                            <tbody className="fw-semibold text-gray-600">
                                                {
                                                    ecomOrderDetails.item_list.map((obj, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td className="fw-bold">{obj.item_name}</td>
                                                                <td>{obj.quantity}</td>
                                                                <td>{ecomOrderDetails.order_currency.currency_symbol} {formatNumber(obj.rate, { ...formatNumberOptions, decimalPlaces: ecomOrderDetails.order_currency.decimal_place })}</td>
                                                                <td>{ecomOrderDetails.order_currency.currency_symbol} {formatNumber(obj.rate * obj.quantity, { ...formatNumberOptions, decimalPlaces: ecomOrderDetails.order_currency.decimal_place })}</td>
                                                                <td>{obj.applied_tax_percentage} %</td>
                                                                <td>{ecomOrderDetails.order_currency.currency_symbol} {formatNumber(obj.rate * obj.quantity * obj.applied_tax_percentage / 100, { ...formatNumberOptions, decimalPlaces: ecomOrderDetails.order_currency.decimal_place })}</td>
                                                                <td className="text-end">{ecomOrderDetails.order_currency.currency_symbol} {formatNumber((obj.rate * obj.quantity) + (obj.rate * obj.quantity * obj.applied_tax_percentage / 100), { ...formatNumberOptions, decimalPlaces: ecomOrderDetails.order_currency.decimal_place })}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between">
                                        <div className="d-flex gap-5 mw-md-300px">
                                            <span className="text-muted">
                                                <div className="d-flex align-items-center">
                                                    <span className="svg-icon svg-icon-2 me-2">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cash-coin" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0" />
                                                            <path d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195z" />
                                                            <path d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z" />
                                                            <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 6 6 0 0 1 3.13-1.567" />
                                                        </svg>
                                                    </span>Coupon:
                                                </div>
                                            </span>
                                            <span className="fw-bold text-end">{ecomOrderDetails.coupon_id === null ? "No notes provided" : (ecomOrderDetails.coupon_id)}</span>
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <div className="mw-300px">
                                                <div className="d-flex flex-stack mb-3">
                                                    <div className="fw-semibold pe-10 text-gray-600 fs-7">Subtotal:</div>
                                                    <div className="text-end fw-bold fs-6 text-gray-800">{ecomOrderDetails.order_currency.currency_symbol} {formatNumber(ecomOrderDetails.item_list.reduce((p, o) => { return p + ((o.rate * o.quantity) + (o.rate * o.quantity * o.applied_tax_percentage / 100)) }, 0), { ...formatNumberOptions, decimalPlaces: ecomOrderDetails.order_currency.decimal_place })}</div>
                                                </div>
                                                {
                                                    ecomOrderDetails.tax_category !== null &&
                                                    <div className="d-flex flex-stack mb-3">
                                                        <div className="fw-semibold pe-10 text-gray-600 fs-7">Shipping Amount:</div>
                                                        <div className="text-end fw-bold fs-6 text-gray-800">{ecomOrderDetails.order_currency.currency_symbol} {ecomOrderDetails.shipping_amount}</div>
                                                    </div>
                                                }
                                                <div className="d-flex flex-stack mb-3">
                                                    <div className="fw-semibold pe-10 text-gray-600 fs-7">Discount:</div>
                                                    <div className="text-end fw-bold fs-6 text-gray-800">{ecomOrderDetails.order_currency.currency_symbol} {ecomOrderDetails.discount_amount}</div>
                                                </div>
                                                <div className="d-flex flex-stack">
                                                    <div className="fw-semibold pe-10 text-gray-600 fs-7">Total</div>
                                                    <div className="text-end fw-bold fs-6 text-gray-800">{ecomOrderDetails.order_currency.currency_symbol} {ecomOrderDetails.order_amount}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card card-flush py-6 flex-row-fluid">
                        <div className="card-header">
                            <div className="card-title">
                                <h2>Additional Information</h2>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
                                    <tbody className="fw-semibold text-gray-600">
                                        <tr>
                                            <td className="text-muted">
                                                <div className="d-flex align-items-center">
                                                    <span className="svg-icon svg-icon-2 me-2">
                                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
                                                            <path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
                                                        </svg>
                                                    </span>Order Notes
                                                </div>
                                            </td>
                                            <td className="fw-bold text-end">{ecomOrderDetails.order_notes === null ? "No notes provided" : (ecomOrderDetails.order_notes)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            }
        </>
    );
};

export const EcommerceOrderAssociatedInvoices = ({ invoiceList }) => {
    return (
        <Accordion>
            {
                invoiceList.map((invoice, index) => {
                    const otherInvoice = invoiceList[index === 0 ? 1 : 0]
                    return (
                        <Accordion.Item eventKey={index} key={invoice.invoice_number}>
                            <Accordion.Header>
                                <h2>#{invoice.invoice_number} - #{invoice.ref_order_id}</h2>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="card card-flush py-6 flex-row-fluid border border-success mb-5">
                                    <div className="card-header">
                                        <div className="card-title">
                                            <h2>#{invoice.invoice_number} - #{invoice.ref_order_id}</h2>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <div className="table-responsive">
                                            <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
                                                <tbody className="fw-semibold text-gray-600">
                                                    <tr>
                                                        <td className="text-muted">
                                                            <div className="d-flex align-items-center">
                                                                <span className="svg-icon svg-icon-2 me-2">
                                                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
                                                                        <path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span>Invoice Tax Type
                                                            </div>
                                                        </td>
                                                        <td className="fw-bold text-end">{invoice.invoice_tax_type}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-muted">
                                                            <div className="d-flex align-items-center">
                                                                <span className="svg-icon svg-icon-2 me-2">
                                                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
                                                                        <path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span>GSTIN
                                                            </div>
                                                        </td>
                                                        <td className="fw-bold text-end">{invoice.organization_gstin_number}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
                                        <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
                                            <div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
                                                <img src="/assets/media/icons/duotune/ecommerce/ecm001.svg" className="w-175px" alt="Location Icon" />
                                            </div>
                                            <div className="card-header">
                                                <div className="card-title">
                                                    <h2>Shipping Address</h2>
                                                </div>
                                            </div>
                                            <div className="card-body pt-0">
                                                <div className="address-info">
                                                    <div className="location">
                                                        <i className="fas fa-map-marker-alt"></i> {invoice.shipping_address.address}, {invoice.shipping_address.city}, {invoice.shipping_address.state}
                                                    </div>
                                                    <div className="pincode">
                                                        <i className="fas fa-thumbtack"></i> {invoice.shipping_address.zip_code}
                                                    </div>
                                                    <div className="country">
                                                        <i className="fas fa-globe"></i> {invoice.shipping_address?.country || "India"}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <div className="table-responsive border-bottom mb-9">
                                            <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                                <thead>
                                                    <tr className="border-bottom fs-6 fw-bold text-muted">
                                                        <th className="min-w-100px">Products</th>
                                                        <th className="min-w-70px">Quantity</th>
                                                        <th className="min-w-70px">Rate<br />(Tax Exclusive)</th>
                                                        <th className="min-w-70px">Total Amt.</th>
                                                        <th className="min-w-70px">Tax Percentage</th>
                                                        <th className="min-w-70px">Tax Amount</th>
                                                        <th className="min-w-100px text-end pb-2">Line Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="fw-semibold text-gray-600">
                                                    {
                                                        invoice.item_list.map((obj, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td className="fw-bold">{obj.item_name}</td>
                                                                    <td>{obj.quantity}</td>
                                                                    <td>{invoice.invoice_currency.currency_symbol} {formatNumber(obj.rate, { ...formatNumberOptions, decimalPlaces: invoice.invoice_currency.decimal_place })}</td>
                                                                    <td>{invoice.invoice_currency.currency_symbol} {formatNumber(obj.rate * obj.quantity, { ...formatNumberOptions, decimalPlaces: invoice.invoice_currency.decimal_place })}</td>
                                                                    <td>{obj.taxable ? <span>{obj.applied_tax_percentage} % {obj.applied_tax.tax_group_details?.map(x => (<span className="badge badge-primary me-1">{x.tax_type} {x.tax_percentage}%</span>))}</span> : "N/A"}</td>
                                                                    <td>{obj.taxable ? <span>{invoice.invoice_currency.currency_symbol} {formatNumber(obj.rate * obj.quantity * obj.applied_tax_percentage / 100, { ...formatNumberOptions, decimalPlaces: invoice.invoice_currency.decimal_place })}</span> : "N/A"}</td>
                                                                    <td className="text-end">{invoice.invoice_currency.currency_symbol} {formatNumber((obj.rate * obj.quantity) + (obj.rate * obj.quantity * obj.applied_tax_percentage / 100), { ...formatNumberOptions, decimalPlaces: invoice.invoice_currency.decimal_place })}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="mw-300px ms-auto">
                                            <div className="d-flex flex-stack mb-3">
                                                <div className="fw-semibold pe-10 text-gray-600 fs-7">Subtotal:</div>
                                                <div className="text-end fw-bold fs-6 text-gray-800">{invoice.invoice_currency.currency_symbol} {formatNumber(invoice.invoice_amount, { ...formatNumberOptions, decimalPlaces: invoice.invoice_currency.decimal_place })}</div>
                                            </div>
                                            {
                                                invoiceList.length > 1 &&
                                                <div className="d-flex flex-stack mb-3">
                                                    <div className="fw-semibold pe-10 text-gray-600 fs-7">Subtotal <span className="fw-bold text-black">(#{otherInvoice.invoice_number})</span>:</div>
                                                    <div className="text-end fw-bold fs-6 text-gray-800">{otherInvoice.invoice_currency.currency_symbol} {formatNumber(otherInvoice.invoice_amount, { ...formatNumberOptions, decimalPlaces: otherInvoice.invoice_currency.decimal_place })}</div>
                                                </div>
                                            }
                                            <div className="d-flex flex-stack mb-3">
                                                <div className="fw-semibold pe-10 text-gray-600 fs-7">Shipping Amount:</div>
                                                <div className="text-end fw-bold fs-6 text-gray-800">{invoice.invoice_currency.currency_symbol} {formatNumber(invoice.shipping_amount, { ...formatNumberOptions, decimalPlaces: invoice.invoice_currency.decimal_place })}</div>
                                            </div>
                                            <div className="d-flex flex-stack mb-3">
                                                <div className="fw-semibold pe-10 text-gray-600 fs-7">Discount:</div>
                                                <div className="text-end fw-bold fs-6 text-gray-800">{invoice.invoice_currency.currency_symbol} {formatNumber(invoice.discount_amount, { ...formatNumberOptions, decimalPlaces: invoice.invoice_currency.decimal_place })}</div>
                                            </div>
                                            <div className="d-flex flex-stack">
                                                <div className="fw-semibold pe-10 text-gray-600 fs-7">Total</div>
                                                <div className="text-end fw-bold fs-6 text-gray-800">{invoice.invoice_currency.currency_symbol} {formatNumber(invoice.order_amount, { ...formatNumberOptions, decimalPlaces: invoice.invoice_currency.decimal_place })}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    )
                })
            }
        </Accordion>
    );
};

export const EcommerceWarehouseProcessingSummary = ({ warehouseProcessingDetails, warehouseList }) => {
    const treeData = useMemo(() => {
        if (warehouseProcessingDetails.length && warehouseList.length) {
            return warehouseProcessingDetails[0].item_array.map(item => {
                return {
                    title: <>
                        {item.item_name}
                        {
                            item.item_stock_type === "Track Serial Number" ? <span className="badge badge-light-primary ms-3 fs-5">Serial</span> :
                                item.item_stock_type === "Track Batches" ? <span className="badge badge-light-info ms-3 fs-5">Batch</span> :
                                    item.item_stock_type === "None" && <span className="badge badge-secondary ms-3 fs-5">Quantity</span>
                        }
                    </>,
                    key: uuid(),
                    children: item.warehouse_list.map(w => {
                        return {
                            title: warehouseList.find(x => x.wid === w.warehouse_id).name,
                            key: uuid(),
                            children: [
                                {
                                    title: `Quantity: ${w.quantity} units`,
                                    key: uuid(),
                                },
                                ...(
                                    item.item_stock_type === "Track Serial Number" || item.item_stock_type === "Track Batches" ? [{
                                        title: item.item_stock_type === "Track Serial Number" ? "Serial Data" : "Batch Data",
                                        key: uuid(),
                                        children: w.item_data?.map(sb => {
                                            if (item.item_stock_type === "Track Serial Number") {
                                                return {
                                                    title: sb.serial_name,
                                                    key: uuid(),
                                                }
                                            }
                                            else {
                                                return {
                                                    title: `${sb.batch_reference} --- ${sb.unit} units`,
                                                    key: uuid(),
                                                }
                                            }
                                        })
                                    }] : []
                                )
                            ]
                        }
                    })
                }
            })
        }
        else {
            return []
        }
    }, [warehouseProcessingDetails, warehouseList])

    return (
        <div className="card p-5">
            <Tree
                showLine
                treeData={treeData}
                style={{ fontSize: "18px" }}
            />
        </div>
    );
};

export const EcommerceOrderAssociatedChallans = ({ deliveryChallanList, warehouseList }) => {
    const treeData = useMemo(() => {
        if (deliveryChallanList.length && warehouseList.length) {
            return deliveryChallanList.map(dc => {
                return {
                    title: <span className="fw-bold fs-1">{dc.ecom_delivery_challan_number}</span>,
                    key: dc.ecom_delivery_challan_id,
                    children: dc.item_array.map(item => {
                        return {
                            title: <>
                                {item.item_name}
                                {
                                    item.item_stock_type === "Track Serial Number" ? <span className="badge badge-light-primary ms-3 fs-5">Serial</span> :
                                        item.item_stock_type === "Track Batches" ? <span className="badge badge-light-info ms-3 fs-5">Batch</span> :
                                            item.item_stock_type === "None" && <span className="badge badge-secondary ms-3 fs-5">Quantity</span>
                                }
                            </>,
                            key: uuid(),
                            children: item.warehouse_list.map(w => {
                                return {
                                    title: warehouseList.find(x => x.wid === w.warehouse_id).name,
                                    key: uuid(),
                                    children: [
                                        {
                                            title: `Quantity: ${w.quantity} units`,
                                            key: uuid(),
                                        },
                                        ...(
                                            item.item_stock_type === "Track Serial Number" || item.item_stock_type === "Track Batches" ? [{
                                                title: item.item_stock_type === "Track Serial Number" ? "Serial Data" : "Batch Data",
                                                key: uuid(),
                                                children: w.item_data?.map(sb => {
                                                    if (item.item_stock_type === "Track Serial Number") {
                                                        return {
                                                            title: sb.serial_name,
                                                            key: uuid(),
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            title: `${sb.batch_reference} --- ${sb.unit} units`,
                                                            key: uuid(),
                                                        }
                                                    }
                                                })
                                            }] : []
                                        )
                                    ]
                                }
                            })
                        }
                    })
                }
            })
        }
        else {
            return []
        }
    }, [deliveryChallanList, warehouseList])

    return (
        <div className="card p-5">
            <Tree
                showLine
                treeData={treeData}
                style={{ fontSize: "18px" }}
            />
        </div>
    );
};

export default ViewEcommerceOrder;
